import { type UIEvent } from 'react';

const DEFAULT_LOADING_OFFSET_PX = 30;

export type UseInfinitePickerParams = {
  fetchNextPage?: () => void;
  loadMore?: () => void;
  hasMore?: boolean;
  isLoading?: boolean;
  isFetchingNextPage?: boolean;
  loadingOffsetPx?: number;
};

type UseInfinitePickerReturn = {
  onListScroll: (event: UIEvent<HTMLDivElement>) => void;
};

export const useInfinitePicker = ({
  fetchNextPage,
  loadMore,
  hasMore = false,
  isLoading = false,
  isFetchingNextPage = false,
  loadingOffsetPx = DEFAULT_LOADING_OFFSET_PX,
}: UseInfinitePickerParams): UseInfinitePickerReturn => {
  const nextPage = fetchNextPage ?? loadMore;

  const onListScroll = (event: UIEvent<HTMLDivElement>) => {
    const target = event.target as HTMLDivElement;

    if (
      nextPage &&
      hasMore &&
      !isLoading &&
      !isFetchingNextPage &&
      target.scrollTop + target.offsetHeight >= target.scrollHeight - loadingOffsetPx
    ) {
      nextPage();
    }
  };

  return {
    onListScroll,
  };
};
